<template>
    <div id="table-demo">

    <div class="sticky-table-header">
        <vx-card style="overflow-x: auto;">
            <vs-row>
                <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
            <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan suhu" v-model="searchText"/>
            <vs-spacer></vs-spacer>
            <vs-tooltip text="Tambah">
              <vs-button radius size="large" type="border" color="#5d9fc6" icon="person_add" class="ml-3" @click="create()"></vs-button>
            </vs-tooltip>
            <vs-tooltip text="Edit" v-if="btnEdit === true">
              <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit()"></vs-button>
            </vs-tooltip>
            <vs-tooltip text="Hapus" v-if="btnDel === true">
              <vs-button radius size="large" type="border" color="#danger" icon="delete" class="ml-3"></vs-button>
            </vs-tooltip>
          </vs-col>
        </vs-row>
      </vx-card>
    </div>      
      
      <vx-card title="List Lokasi Penyimpanan" class="sticky-table-content mt-sticky">
        <vs-table stripe max-items="10" class="mb-base" :data="listData" style="text-align:center;" @selected="handleSelected">
            <template slot="thead">
                <vs-th>No Rak/Kulkas</vs-th>
				<vs-th>Baris</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :state="tr.id==idSelected?'primary':null" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        {{data[indextr].no}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].shelf}}
                    </vs-td>					
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>			
      </vx-card>
    </div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import stock from "@/api/stock.js";
import tool from "@/tool/form_tool.js";
export default {
	data() {
		return {
			idSelected: null,
			listData: [],
			loading: true,
			perPage: 50,
			page: 1,
      		totalItem: 1,
      
			btnEdit: false,
			btnDel: false,

			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
            searchText: ''
		};
	},
	methods: {
		listen(newVal, schema) {
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			this.listData= {maxPage:0, data: []};
			const frm = await stock.listLokasi(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			}
		},
		async firstLoad() {
			//const frms = await formsearch.getFormKeywordProvince();
			//this.schema.fields = frms.data.data[0].fields;
			//this.model = frms.data.data[0].model;
			this.find(1);			
		},
		handleSelected(tr) {
			this.idSelected = tr.id;
			this.btnEdit = true;
			this.btnDel = true;
		},        
		create() {
			this.$router.push('/inventory/lokasi/create');
		},
		edit() {
			this.$router.push({name: 'edit-lokasi', params: {id: this.idSelected}});
		},		
	},
	computed: {},
	created() {
		this.firstLoad();
	},
};
</script>